/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Preview_Project_1Inputs */



/**
* | output |
* | --- |
* | "Oliver's website relaunch" |
*
* @param {Sidebar_Preview_Project_1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sidebar_preview_project_1 = /** @type {((inputs?: Sidebar_Preview_Project_1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Preview_Project_1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Olivers Website-Relaunch")
	return /** @type {LocalizedString} */ ("Oliver's website relaunch")
});